@if (attachments?.length) {
  <div>
    <p-table
      styleClass="shadow"
      [value]="attachments"
      class="card-table card-table-asset-view"
      [alwaysShowPaginator]="false"
      [paginator]="showPaginator(attachments)"
      [rows]="rowsPerPage"
      [customSort]="false"
      [sortField]="(currentSort ? currentSort.field : null)"
      [sortOrder]="(currentSort ? currentSort.order : 1)">
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="created_at">
            Date
            <p-sortIcon field="created_at"></p-sortIcon>
          </th>
          <th pSortableColumn="user_name">
            User
            <p-sortIcon field="user_name"></p-sortIcon>
          </th>
          <th pSortableColumn="original_name">
            Name
            <p-sortIcon field="original_name"></p-sortIcon>
          </th>
          @if (showAttachmenttype) {
            <th pSortableColumn="group_name">
              Group/Subgroup
              <p-sortIcon field="group_name"></p-sortIcon>
            </th>
          }
          @if (deleteEnabled) {
            <th class="col-button" ></th>
          }
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-attachment>
        <tr>
          <td>{{attachment.date}}</td>
          <td>{{attachment.user_name}}</td>
          <td>
            <a href={{attachment?.link}}>
              {{attachment?.original_name}}
            </a>
          </td>
          @if (showAttachmenttype) {
            <td >{{attachment.group_name}}</td>
          }
          @if (deleteEnabled) {
            <td>
              <mat-icon class="edit-btn clickable" (click)="deleteAttachment(attachment)" svgIcon="delete"></mat-icon>
            </td>
          }
        </tr>
      </ng-template>
    </p-table>
  </div>
}
@if (!attachments?.length) {
  <div class="attach-empty-message text-subhead" ngClass.xs="mobile-attach-empty-message">
    You do not have any attachments uploaded yet.
  </div>
}
<div class="attach-button" [ngClass]="{'attach-empty-button': !attachments?.length}">
  <button mat-raised-button type="button" color="primary" (click)="addAttachment()">+Attachment</button>
</div>
